import { ActionContext } from 'vuex'
import { RootState } from '../types'
import rest from '@/rest'

interface ComponentsState {
  components: Record<string, any>
  loading: boolean
}

const state: ComponentsState = {
  components: {},
  loading: false
}

type ComponentsActionContext = ActionContext<ComponentsState, RootState>

const mutations = {
  SET_COMPONENTS (state: ComponentsState, data: Record<string, any>) {
    state.components = data
  },

  SET_LOADING (state: ComponentsState, value: boolean) {
    state.loading = value
  }
}

const actions = {
  async LOAD_COMPONENTS (ctx: ComponentsActionContext) {
    ctx.commit('SET_LOADING', true)
    try {
      const data = await rest.components.getCampaignComponents(ctx.rootGetters['campaigns/currentId'])
      ctx.commit('SET_COMPONENTS', data)
    } finally {
      ctx.commit('SET_LOADING', false)
    }
  },

  async SAVE_COMPONENT (ctx: ComponentsActionContext, component: any) {
    await rest.components.saveComponent(ctx.rootGetters['campaigns/currentId'], component)
    ctx.dispatch(
      'snackbar/SHOW_MESSAGE',
      { content: 'Component saved!', color: 'success' },
      { root: true }
    )
    await ctx.dispatch('LOAD_COMPONENTS')
  }
}

const getters = {
  components: (state: ComponentsState) => state.components,
  loading: (state: ComponentsState) => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
